import type {Props} from "./Typography";
import Typography from "./Typography";

export type TypographyProps = Props;
export default Typography;
